<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro de Categoria de Atendimento">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-8">
          <label for="descricao">Descrição</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro.descricao" type="text" class="form-control form-input-component" required v-bind:class="{ 'is-invalid': submitted && !registro.descricao }" />
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/categoria-atendimento.js';

export default {
  setup() {
    return {};
  },
  data() {
    return {
      submitted: false,
      registro: {},
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity()) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else {
        await create(this.registro).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.registro = {};
          this.submitted = false;
        });
      }
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
  },

  created() {
    this.carregar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
